module.exports = __webpack_public_path__ + "media/Common_Tern.83d7224d.mp3";